import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Temporary enum to replace missing EnumDeviceSensorsUiType
const EnumDeviceSensorsUiType = {
    Temp: 'temp',
    Rpm: 'rpm',
    Ph: 'ph',
};
const MinimalMetricsView = ({ device, liveSensorValues, }) => {
    const getSensorStyle = (type, value) => {
        switch (type) {
            case 'temp':
            case 'temp':
            case EnumDeviceSensorsUiType.Temp:
                return {
                    bg: 'bg-red-50',
                    border: 'border-red-200',
                    text: 'text-red-600',
                    icon: '🌡️',
                    statusColor: value !== null && value > 25 ? 'bg-red-500' : 'bg-green-500',
                    trendColor: value !== null && value > 25 ? 'text-red-500' : 'text-green-500',
                };
            case 'rpm':
            case 'rpm':
            case EnumDeviceSensorsUiType.Rpm:
                return {
                    bg: 'bg-blue-50',
                    border: 'border-blue-200',
                    text: 'text-blue-600',
                    icon: '⚡',
                    statusColor: value !== null && value > 1000 ? 'bg-yellow-500' : 'bg-green-500',
                    trendColor: value !== null && value > 1000
                        ? 'text-yellow-500'
                        : 'text-green-500',
                };
            case 'ph':
            case EnumDeviceSensorsUiType.Ph:
                return {
                    bg: 'bg-green-50',
                    border: 'border-green-200',
                    text: 'text-green-600',
                    icon: '💧',
                    statusColor: value !== null && (value < 6.5 || value > 8.5)
                        ? 'bg-yellow-500'
                        : 'bg-green-500',
                    trendColor: value !== null && (value < 6.5 || value > 8.5)
                        ? 'text-yellow-500'
                        : 'text-green-500',
                };
            default:
                return {
                    bg: 'bg-gray-50',
                    border: 'border-gray-200',
                    text: 'text-gray-600',
                    icon: '📊',
                    statusColor: 'bg-gray-500',
                    trendColor: 'text-gray-500',
                };
        }
    };
    const formatSensorValue = (value, type) => {
        if (value === null || value === undefined || typeof value === 'undefined')
            return '--';
        if (typeof value !== 'number' || isNaN(value) || !isFinite(value))
            return '--';
        switch (type) {
            case 'temp':
            case EnumDeviceSensorsUiType.Temp:
                return `${value.toFixed(1)}`;
            case 'rpm':
            case EnumDeviceSensorsUiType.Rpm:
                return `${value.toFixed(0)}`;
            case 'ph':
            case EnumDeviceSensorsUiType.Ph:
                return `${value.toFixed(1)}`;
            default:
                return value.toString();
        }
    };
    const getUnit = (type) => {
        switch (type) {
            case 'temp':
            case EnumDeviceSensorsUiType.Temp:
                return '°C';
            case 'rpm':
            case EnumDeviceSensorsUiType.Rpm:
                return 'Hz';
            case 'ph':
            case EnumDeviceSensorsUiType.Ph:
                return 'pH';
            default:
                return '';
        }
    };
    const getTrendIcon = (type, value) => {
        if (value === null)
            return '➖';
        switch (type) {
            case 'temp':
            case EnumDeviceSensorsUiType.Temp:
                return value > 25 ? '📈' : value < 15 ? '📉' : '➡️';
            case 'rpm':
            case EnumDeviceSensorsUiType.Rpm:
                return value > 1000 ? '📈' : value < 500 ? '📉' : '➡️';
            case 'ph':
            case EnumDeviceSensorsUiType.Ph:
                return value > 8.5 || value < 6.5 ? '⚠️' : '✅';
            default:
                return '➡️';
        }
    };
    const sensors = device.sensorsUI || [];
    return (_jsxs("div", { className: "bg-white rounded-2xl shadow-lg border border-gray-200 p-6", children: [_jsxs("div", { className: "mb-8", children: [_jsx("h1", { className: "text-3xl font-light text-gray-900 mb-2", children: device.deviceLabel || device.deviceName || 'Sensor Metrics' }), _jsxs("div", { className: "flex items-center gap-4 text-sm text-gray-500", children: [_jsxs("span", { className: "flex items-center gap-1", children: [_jsx("div", { className: "w-2 h-2 bg-green-500 rounded-full animate-pulse" }), "Live Data"] }), _jsx("span", { children: "\u2022" }), _jsxs("span", { children: [sensors.length, " Active Sensors"] }), _jsx("span", { children: "\u2022" }), _jsx("span", { children: "Updated Just Now" })] })] }), _jsx("div", { className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-8", children: sensors.map((sensor, index) => {
                    if (!sensor)
                        return null;
                    const value = liveSensorValues[sensor.sensorName];
                    const formattedValue = formatSensorValue(value, sensor.type);
                    const unit = getUnit(sensor.type);
                    const styles = getSensorStyle(sensor.type, value);
                    const trendIcon = getTrendIcon(sensor.type, value);
                    return (_jsxs("div", { className: `
                group relative p-6 rounded-xl border ${styles.border}
                hover:shadow-lg transition-all duration-200
                hover:scale-105 cursor-pointer
                ${styles.bg}
              `, children: [_jsxs("div", { className: "flex items-center justify-between mb-4", children: [_jsx("div", { className: "text-2xl", children: styles.icon }), _jsx("div", { className: `w-2 h-2 rounded-full ${styles.statusColor} animate-pulse` })] }), _jsxs("div", { className: "mb-2", children: [_jsx("div", { className: `text-4xl font-light ${styles.text} mb-1`, children: formattedValue }), _jsx("div", { className: `text-sm ${styles.text} opacity-70`, children: unit })] }), _jsxs("div", { className: "flex items-center justify-between", children: [_jsx("div", { className: `text-sm font-medium ${styles.text}`, children: sensor.label }), _jsx("div", { className: `text-lg ${styles.trendColor}`, children: trendIcon })] }), _jsx("div", { className: "absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10", children: _jsxs("div", { className: "bg-gray-900 text-white text-xs rounded-lg p-3 whitespace-nowrap shadow-xl", children: [_jsx("div", { className: "font-semibold mb-1", children: sensor.label }), _jsxs("div", { children: ["Sensor: ", sensor.sensorName] }), _jsxs("div", { children: ["Type: ", sensor.type] }), _jsxs("div", { children: ["Value: ", formattedValue, " ", unit] }), _jsx("div", { className: "absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-900" })] }) })] }, `sensor-${index}`));
                }) }), _jsxs("div", { className: "grid grid-cols-2 md:grid-cols-4 gap-4 pt-6 border-t border-gray-200", children: [_jsxs("div", { className: "text-center", children: [_jsx("div", { className: "text-2xl font-bold text-gray-900", children: sensors.length }), _jsx("div", { className: "text-sm text-gray-500", children: "Total Sensors" })] }), _jsxs("div", { className: "text-center", children: [_jsx("div", { className: "text-2xl font-bold text-green-600", children: sensors.filter((s) => {
                                    if (!(s === null || s === void 0 ? void 0 : s.sensorName))
                                        return false;
                                    const value = liveSensorValues[s.sensorName];
                                    const styles = getSensorStyle(s.type, value);
                                    return styles.statusColor === 'bg-green-500';
                                }).length }), _jsx("div", { className: "text-sm text-gray-500", children: "Normal" })] }), _jsxs("div", { className: "text-center", children: [_jsx("div", { className: "text-2xl font-bold text-yellow-600", children: sensors.filter((s) => {
                                    if (!(s === null || s === void 0 ? void 0 : s.sensorName))
                                        return false;
                                    const value = liveSensorValues[s.sensorName];
                                    const styles = getSensorStyle(s.type, value);
                                    return styles.statusColor === 'bg-yellow-500';
                                }).length }), _jsx("div", { className: "text-sm text-gray-500", children: "Warning" })] }), _jsxs("div", { className: "text-center", children: [_jsx("div", { className: "text-2xl font-bold text-red-600", children: sensors.filter((s) => {
                                    if (!(s === null || s === void 0 ? void 0 : s.sensorName))
                                        return false;
                                    const value = liveSensorValues[s.sensorName];
                                    const styles = getSensorStyle(s.type, value);
                                    return styles.statusColor === 'bg-red-500';
                                }).length }), _jsx("div", { className: "text-sm text-gray-500", children: "Critical" })] })] }), _jsxs("div", { className: "mt-6 flex flex-wrap gap-2", children: [_jsx("button", { className: "px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors text-sm", children: "\uD83D\uDCCA View Charts" }), _jsx("button", { className: "px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors text-sm", children: "\uD83D\uDCC4 Export Data" }), _jsx("button", { className: "px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors text-sm", children: "\u2699\uFE0F Settings" })] })] }));
};
export default MinimalMetricsView;
